$(document).ready(function() {
    var windowTop = $(window).scrollTop();
    var windowWidth = $(window).width();

	$('.navigation-link, .js-open-meganav').click(function(e) {
        e.stopPropagation();
        if (windowWidth < 1248) {
            var parent = $(this).closest('.navigation-main-item');
            if ($(parent).hasClass('is-selected')) {
                    $(parent).removeClass('is-selected');
                    megaGridAnim(parent);
            } else {
                    $(parent).addClass('is-selected');
                    megaGridAnim(parent);
            }
        }
    });

    $(".navLink__anchor, .js-open-meganav").on("click tap", function(e) {
        e.stopPropagation();
    });

	$('.navigation-main-items')
        .mouseenter(function() {
            $('.navigation-primary').addClass('is-active-desktop');
        })
        .mouseleave(function() {
            $('.navigation-primary').removeClass('is-active-desktop');
        });

    $('.navigation-mega-title').click(function() {
        var parent = $(this).closest('.navigation-main-item');
        $(parent).removeClass('is-selected');
    });

    function megaGridAnim(parent) {
        var megaNavSub = $(parent).find('.navigation-mega-grid .navsub');
        $(megaNavSub).each(function(idx, el) {
            var lists = $(el).find('li');
            if ($(parent).hasClass('is-selected')) {
                    listAnim($(lists), 1);
            } else {
                    listAnim($(lists), 0);
            }
        })
    }

	function windowPos() {
		var windowTop = $(window).scrollTop();
		if (windowTop > 0) {
			$('.navigation-primary').addClass('is-active');
		} else {
			$('.navigation-primary').removeClass('is-active');
		}
	}

	function mainLinkCheck() {
		$('.navigation-main-item').each(function(idx, item) {
            var megaNav = $(item).find('.navigation-mega');
			if (megaNav.length > 0) {
				$(item).addClass('navigation-main-item-parent');
			}
		});
	}

	function mobileNavBurger() {
        let elem = $('.navigation-main-item, .navigation-utility__mobileLinks li');
        let bottomDropdown = $(".navigation-utility__mobileBottom .navigation-utility__item--dropdown");
        let mobileLogin = $(".navigation-utility__mobileLinks .js-toggle");

		$('.menu-open').click(function() {
			$('body').addClass('js-nav-active');
            listAnim(elem, 1);
		});

		$('.menu-close').click(function() {
			$('body').removeClass('js-nav-active');
            $('.navigation-main-item').removeClass('is-selected');
            if (!windowTop > 0) {
                $('.navigation-primary').removeClass('is-active');
            }
            if (bottomDropdown.hasClass("navigation-utility__item--active")) bottomDropdown.click();
            mobileLogin.hide();
            listAnim(elem, 0);
		});
	}

    function mobileSearchMenu1() {
        $('.search-mobile-button').click(function() {
            $('body').addClass('js-nav-active');
            $('.search-mobile-area').addClass('js-mob-search-active');
        });

        $('.search-mobile-close').click(function() {
            $('body').removeClass('js-nav-active');
            $('.search-mobile-area').removeClass('js-mob-search-active');
        });
    }

    function listAnim(el, trigger) {
        el.each(function(idx, item) {
            let duration = 50 * idx;
            $(item).removeClass('list-active');

            if (trigger) {
                setTimeout(function() {
                    $(item).addClass('list-active');
                }, duration);
            }
		});
    } 

    function resizeCheck() {
        $(window).on('resize', function() {
            windowWidth = $(this).width();

            if (windowWidth > 1247) {
                $('body').removeClass('js-nav-active');
                $('.navigation-main-item').removeClass('is-selected');
                $('.navigation-main-item').removeClass('list-active');
            }
        });
    }
	
	$(window).scroll(function() {
		windowPos();
	});

	windowPos();
	mobileNavBurger();
    mobileSearchMenu1();
	mainLinkCheck();
    resizeCheck();
});
